import { useState } from "react";
import { Map, Download, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { swMessage, useTileStats, useInstallPrompt, isInstalled, isIOSSafari } from "../lib/pwa";
import { InstallCard } from "./Pwa";
import { BUILD_ID } from "./SwUpdateBanner";

const fmtMB = (b) => (b == null ? "—" : `${(b / 1048576).toFixed(1)} MB`);

export const OfflineMapsCard = () => {
  const [gen, setGen] = useState(0);
  const stats = useTileStats(gen);
  const clear = async () => { await swMessage({ type: "CLEAR_TILES" }); setGen((g) => g + 1); toast.success("Map cache cleared"); };
  return (
    <section className="card fade-up" data-testid="offline-maps-card">
      <p className="eyebrow flex items-center gap-1"><Map size={12} /> Offline maps</p>
      <h2 className="card-title">Cached map tiles</h2>
      <p className="text-sm text-muted mt-2">Areas you've viewed stay available offline (capped at ~30 MB, 30 days).</p>
      <div className="grid grid-cols-2 gap-3 mt-3">
        <div className="result"><p className="eyebrow">Tiles</p><p className="text-xl font-black" data-testid="tile-count">{stats ? stats.count : "…"}</p></div>
        <div className="result"><p className="eyebrow">Approx. size</p><p className="text-xl font-black" data-testid="tile-size">{stats ? fmtMB(stats.approxBytes) : "…"}</p></div>
      </div>
      <p className="text-xs text-muted mt-2" data-testid="storage-total">Total site storage: {stats ? fmtMB(stats.total) : "…"}</p>
      <button type="button" className="btn-secondary mt-3 flex items-center justify-center gap-2" onClick={clear} data-testid="clear-map-cache"><Trash2 size={16} /> Clear map cache</button>
    </section>
  );
};

export const InstallSettingsCard = () => {
  const { canInstall, install } = useInstallPrompt();
  const [ios, setIos] = useState(false);
  if (isInstalled()) return <section className="card fade-up" data-testid="install-settings-card"><p className="eyebrow">App</p><p className="font-bold mt-1">DropIt is installed ✓</p><p className="text-xs text-muted mt-1 notranslate" translate="no">Build <span data-testid="build-id">{BUILD_ID}</span></p></section>;
  return (
    <section className="card fade-up" data-testid="install-settings-card">
      <p className="eyebrow flex items-center gap-1"><Download size={12} /> App</p>
      <h2 className="card-title">Install <span className="notranslate" translate="no">DropIt</span></h2>
      <p className="text-sm text-muted mt-2">Home-screen icon, full screen, works offline.</p>
      {canInstall ? <button type="button" className="btn-primary mt-3" onClick={install} data-testid="settings-install-button">Install app</button>
        : <button type="button" className="btn-secondary mt-3" onClick={() => setIos(true)} data-testid="settings-install-howto">{isIOSSafari() ? "Install app" : "How to install"}</button>}
      {ios && <InstallCard forceIOS onClose={() => setIos(false)} />}
      <p className="text-xs text-muted mt-3 notranslate" translate="no">Build <span data-testid="build-id">{BUILD_ID}</span></p>
    </section>
  );
};
